export default __webpack_public_path__ + "static/media/9.365e4ae3.png";